//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  citext: any;
  date: any;
  timestamptz: string;
  uuid: string;
}


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface BooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

export interface MessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface Session {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface StringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface UserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** input type for inserting data into table "assignment_notes" */
export interface AssignmentNotesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "assignment_notes" */
export interface AssignmentNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
}

/** columns and relationships of "auth.account_providers" */
export interface AuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<AuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface AuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface AuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface AuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface AuthAccountProvidersAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountProvidersMaxOrderBy>;
  min?: Maybe<AuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface AuthAccountProvidersArrRelInsertInput {
  data: Array<AuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface AuthAccountProvidersBoolExp {
  _and?: Maybe<Array<AuthAccountProvidersBoolExp>>;
  _not?: Maybe<AuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<AuthAccountProvidersBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  auth_provider?: Maybe<StringComparisonExp>;
  auth_provider_unique_id?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  provider?: Maybe<AuthProvidersBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum AuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface AuthAccountProvidersInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<AuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface AuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface AuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface AuthAccountProvidersMinOrderBy {
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface AuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface AuthAccountProvidersOnConflict {
  constraint: AuthAccountProvidersConstraint;
  update_columns?: Array<AuthAccountProvidersUpdateColumn>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface AuthAccountProvidersOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  provider?: Maybe<AuthProvidersOrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface AuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum AuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface AuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum AuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface AuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<AuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface AuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface AuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface AuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface AuthAccountRolesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountRolesMaxOrderBy>;
  min?: Maybe<AuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface AuthAccountRolesArrRelInsertInput {
  data: Array<AuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface AuthAccountRolesBoolExp {
  _and?: Maybe<Array<AuthAccountRolesBoolExp>>;
  _not?: Maybe<AuthAccountRolesBoolExp>;
  _or?: Maybe<Array<AuthAccountRolesBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  roleByRole?: Maybe<AuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum AuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface AuthAccountRolesInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<AuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface AuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface AuthAccountRolesMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface AuthAccountRolesMinOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface AuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface AuthAccountRolesOnConflict {
  constraint: AuthAccountRolesConstraint;
  update_columns?: Array<AuthAccountRolesUpdateColumn>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface AuthAccountRolesOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  roleByRole?: Maybe<AuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface AuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum AuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface AuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum AuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface AuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<AuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<AuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<AuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface AuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface AuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface AuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface AuthAccountsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountsMaxOrderBy>;
  min?: Maybe<AuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface AuthAccountsArrRelInsertInput {
  data: Array<AuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface AuthAccountsBoolExp {
  _and?: Maybe<Array<AuthAccountsBoolExp>>;
  _not?: Maybe<AuthAccountsBoolExp>;
  _or?: Maybe<Array<AuthAccountsBoolExp>>;
  account_providers?: Maybe<AuthAccountProvidersBoolExp>;
  account_roles?: Maybe<AuthAccountRolesBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  default_role?: Maybe<StringComparisonExp>;
  email?: Maybe<CitextComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  insurance_number?: Maybe<PrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<BooleanComparisonExp>;
  new_email?: Maybe<CitextComparisonExp>;
  password_hash?: Maybe<StringComparisonExp>;
  refresh_tokens?: Maybe<AuthRefreshTokensBoolExp>;
  role?: Maybe<AuthRolesBoolExp>;
  ticket?: Maybe<UuidComparisonExp>;
  ticket_expires_at?: Maybe<TimestamptzComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum AuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface AuthAccountsInsertInput {
  account_providers?: Maybe<AuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<AuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<PrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<AuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<AuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface AuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface AuthAccountsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface AuthAccountsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface AuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface AuthAccountsObjRelInsertInput {
  data: AuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface AuthAccountsOnConflict {
  constraint: AuthAccountsConstraint;
  update_columns?: Array<AuthAccountsUpdateColumn>;
  where?: Maybe<AuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface AuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<AuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<AuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  insurance_number?: Maybe<PrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  refresh_tokens_aggregate?: Maybe<AuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<AuthRolesOrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface AuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum AuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface AuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum AuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface AuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface AuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface AuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface AuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface AuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface AuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface AuthProvidersBoolExp {
  _and?: Maybe<Array<AuthProvidersBoolExp>>;
  _not?: Maybe<AuthProvidersBoolExp>;
  _or?: Maybe<Array<AuthProvidersBoolExp>>;
  account_providers?: Maybe<AuthAccountProvidersBoolExp>;
  provider?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum AuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface AuthProvidersInsertInput {
  account_providers?: Maybe<AuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface AuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface AuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface AuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface AuthProvidersObjRelInsertInput {
  data: AuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface AuthProvidersOnConflict {
  constraint: AuthProvidersConstraint;
  update_columns?: Array<AuthProvidersUpdateColumn>;
  where?: Maybe<AuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface AuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<AuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface AuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum AuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface AuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum AuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface AuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthRefreshTokensMaxOrderBy>;
  min?: Maybe<AuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface AuthRefreshTokensArrRelInsertInput {
  data: Array<AuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface AuthRefreshTokensBoolExp {
  _and?: Maybe<Array<AuthRefreshTokensBoolExp>>;
  _not?: Maybe<AuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<AuthRefreshTokensBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  expires_at?: Maybe<TimestamptzComparisonExp>;
  refresh_token?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum AuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface AuthRefreshTokensInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface AuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface AuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface AuthRefreshTokensMinOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface AuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface AuthRefreshTokensOnConflict {
  constraint: AuthRefreshTokensConstraint;
  update_columns?: Array<AuthRefreshTokensUpdateColumn>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface AuthRefreshTokensOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface AuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum AuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface AuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum AuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface AuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<AuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<AuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface AuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface AuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface AuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface AuthRolesBoolExp {
  _and?: Maybe<Array<AuthRolesBoolExp>>;
  _not?: Maybe<AuthRolesBoolExp>;
  _or?: Maybe<Array<AuthRolesBoolExp>>;
  account_roles?: Maybe<AuthAccountRolesBoolExp>;
  accounts?: Maybe<AuthAccountsBoolExp>;
  role?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum AuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface AuthRolesInsertInput {
  account_roles?: Maybe<AuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<AuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface AuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface AuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface AuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface AuthRolesObjRelInsertInput {
  data: AuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface AuthRolesOnConflict {
  constraint: AuthRolesConstraint;
  update_columns?: Array<AuthRolesUpdateColumn>;
  where?: Maybe<AuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface AuthRolesOrderBy {
  account_roles_aggregate?: Maybe<AuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<AuthAccountsAggregateOrderBy>;
  role?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface AuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum AuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface AuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum AuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface CitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface DateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** mutation root */
export interface MutationRoot {
  change_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
  /** insert data into the table: "assignment_notes" */
  insert_assignment_notes?: EntireFieldWrapper<Maybe<AssignmentNotesMutationResponse>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<Relationships>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<Schools>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<Users>>;
  login_email_password?: EntireFieldWrapper<Maybe<Session>>;
  lost_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<Session>>;
  reset_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
}


/** mutation root */
export interface MutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountProvidersArgs {
  where: AuthAccountProvidersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountRolesArgs {
  where: AuthAccountRolesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountsArgs {
  where: AuthAccountsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthProvidersArgs {
  where: AuthProvidersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeleteAuthRefreshTokensArgs {
  where: AuthRefreshTokensBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthRolesArgs {
  where: AuthRolesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeletePrivateAdressesArgs {
  where: PrivateAdressesBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivateBirthdaysArgs {
  where: PrivateBirthdaysBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivateInsuranceNumbersArgs {
  where: PrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivatePhoneNumbersArgs {
  where: PrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteRelationshipsArgs {
  where: RelationshipsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsArgs {
  where: SchoolSettingsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsModulesArgs {
  where: SchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolsArgs {
  where: SchoolsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteUsersArgs {
  where: UsersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootInsertAssignmentNotesArgs {
  objects: Array<AssignmentNotesInsertInput>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountProvidersArgs {
  objects: Array<AuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountProvidersOneArgs {
  object: AuthAccountProvidersInsertInput;
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountRolesArgs {
  objects: Array<AuthAccountRolesInsertInput>;
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountRolesOneArgs {
  object: AuthAccountRolesInsertInput;
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountsArgs {
  objects: Array<AuthAccountsInsertInput>;
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountsOneArgs {
  object: AuthAccountsInsertInput;
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthProvidersArgs {
  objects: Array<AuthProvidersInsertInput>;
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthProvidersOneArgs {
  object: AuthProvidersInsertInput;
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRefreshTokensArgs {
  objects: Array<AuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRefreshTokensOneArgs {
  object: AuthRefreshTokensInsertInput;
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRolesArgs {
  objects: Array<AuthRolesInsertInput>;
  on_conflict?: Maybe<AuthRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRolesOneArgs {
  object: AuthRolesInsertInput;
  on_conflict?: Maybe<AuthRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateAdressesArgs {
  objects: Array<PrivateAdressesInsertInput>;
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateAdressesOneArgs {
  object: PrivateAdressesInsertInput;
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateBirthdaysArgs {
  objects: Array<PrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateBirthdaysOneArgs {
  object: PrivateBirthdaysInsertInput;
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<PrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: PrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<PrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivatePhoneNumbersOneArgs {
  object: PrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertRelationshipsArgs {
  objects: Array<RelationshipsInsertInput>;
  on_conflict?: Maybe<RelationshipsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertRelationshipsOneArgs {
  object: RelationshipsInsertInput;
  on_conflict?: Maybe<RelationshipsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsArgs {
  objects: Array<SchoolSettingsInsertInput>;
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<SchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsModulesOneArgs {
  object: SchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsOneArgs {
  object: SchoolSettingsInsertInput;
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolsArgs {
  objects: Array<SchoolsInsertInput>;
  on_conflict?: Maybe<SchoolsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolsOneArgs {
  object: SchoolsInsertInput;
  on_conflict?: Maybe<SchoolsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertUsersArgs {
  objects: Array<UsersInsertInput>;
  on_conflict?: Maybe<UsersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertUsersOneArgs {
  object: UsersInsertInput;
  on_conflict?: Maybe<UsersOnConflict>;
}


/** mutation root */
export interface MutationRootLoginEmailPasswordArgs {
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface MutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface MutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface MutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface MutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<AuthAccountProvidersSetInput>;
  where: AuthAccountProvidersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<AuthAccountProvidersSetInput>;
  pk_columns: AuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<AuthAccountRolesSetInput>;
  where: AuthAccountRolesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<AuthAccountRolesSetInput>;
  pk_columns: AuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<AuthAccountsSetInput>;
  where: AuthAccountsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<AuthAccountsSetInput>;
  pk_columns: AuthAccountsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<AuthProvidersSetInput>;
  where: AuthProvidersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<AuthProvidersSetInput>;
  pk_columns: AuthProvidersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<AuthRefreshTokensSetInput>;
  where: AuthRefreshTokensBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<AuthRefreshTokensSetInput>;
  pk_columns: AuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthRolesArgs {
  _set?: Maybe<AuthRolesSetInput>;
  where: AuthRolesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<AuthRolesSetInput>;
  pk_columns: AuthRolesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<PrivateAdressesSetInput>;
  where: PrivateAdressesBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<PrivateAdressesSetInput>;
  pk_columns: PrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<PrivateBirthdaysSetInput>;
  where: PrivateBirthdaysBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<PrivateBirthdaysSetInput>;
  pk_columns: PrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<PrivateInsuranceNumbersSetInput>;
  where: PrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<PrivateInsuranceNumbersSetInput>;
  pk_columns: PrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<PrivatePhoneNumbersSetInput>;
  where: PrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<PrivatePhoneNumbersSetInput>;
  pk_columns: PrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateRelationshipsArgs {
  _set?: Maybe<RelationshipsSetInput>;
  where: RelationshipsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<RelationshipsSetInput>;
  pk_columns: RelationshipsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<SchoolSettingsSetInput>;
  where: SchoolSettingsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<SchoolSettingsSetInput>;
  pk_columns: SchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<SchoolSettingsModulesSetInput>;
  where: SchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<SchoolSettingsModulesSetInput>;
  pk_columns: SchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolsArgs {
  _set?: Maybe<SchoolsSetInput>;
  where: SchoolsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<SchoolsSetInput>;
  pk_columns: SchoolsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateUsersArgs {
  _set?: Maybe<UsersSetInput>;
  where: UsersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateUsersByPkArgs {
  _set?: Maybe<UsersSetInput>;
  pk_columns: UsersPkColumnsInput;
}

/** column ordering options */
export const enum OrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "private.adresses" */
export interface PrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.adresses" */
export interface PrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface PrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface PrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface PrivateAdressesBoolExp {
  _and?: Maybe<Array<PrivateAdressesBoolExp>>;
  _not?: Maybe<PrivateAdressesBoolExp>;
  _or?: Maybe<Array<PrivateAdressesBoolExp>>;
  area?: Maybe<StringComparisonExp>;
  city?: Maybe<StringComparisonExp>;
  country?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  postal_code?: Maybe<StringComparisonExp>;
  street?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum PrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface PrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface PrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface PrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface PrivateAdressesObjRelInsertInput {
  data: PrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface PrivateAdressesOnConflict {
  constraint: PrivateAdressesConstraint;
  update_columns?: Array<PrivateAdressesUpdateColumn>;
  where?: Maybe<PrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface PrivateAdressesOrderBy {
  area?: Maybe<OrderBy>;
  city?: Maybe<OrderBy>;
  country?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  postal_code?: Maybe<OrderBy>;
  street?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface PrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum PrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface PrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum PrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface PrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface PrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface PrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface PrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface PrivateBirthdaysBoolExp {
  _and?: Maybe<Array<PrivateBirthdaysBoolExp>>;
  _not?: Maybe<PrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<PrivateBirthdaysBoolExp>>;
  date?: Maybe<DateComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum PrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface PrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface PrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface PrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface PrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface PrivateBirthdaysObjRelInsertInput {
  data: PrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface PrivateBirthdaysOnConflict {
  constraint: PrivateBirthdaysConstraint;
  update_columns?: Array<PrivateBirthdaysUpdateColumn>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface PrivateBirthdaysOrderBy {
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface PrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum PrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface PrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum PrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface PrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface PrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<PrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<PrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<PrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface PrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersObjRelInsertInput {
  data: PrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersOnConflict {
  constraint: PrivateInsuranceNumbersConstraint;
  update_columns?: Array<PrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface PrivateInsuranceNumbersOrderBy {
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface PrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface PrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface PrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<PrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<PrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<PrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  number?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum PrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface PrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface PrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface PrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface PrivatePhoneNumbersObjRelInsertInput {
  data: PrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface PrivatePhoneNumbersOnConflict {
  constraint: PrivatePhoneNumbersConstraint;
  update_columns?: Array<PrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface PrivatePhoneNumbersOrderBy {
  country_code?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface PrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum PrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface PrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum PrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface QueryRoot {
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<AuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<AuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<AuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<AuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<AuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<AuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<AuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<AuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  me?: EntireFieldWrapper<Maybe<UserData>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<PrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<PrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<PrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<PrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<PrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<PrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<Relationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<SchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<SchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<SchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<SchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<Schools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<SchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<Users>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<UsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
}


export interface QueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


export interface QueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


export interface QueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


export interface QueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


export interface QueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


export interface QueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


export interface QueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<AuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProvidersOrderBy>>;
  where?: Maybe<AuthProvidersBoolExp>;
}


export interface QueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProvidersOrderBy>>;
  where?: Maybe<AuthProvidersBoolExp>;
}


export interface QueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface QueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


export interface QueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


export interface QueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface QueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<AuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRolesOrderBy>>;
  where?: Maybe<AuthRolesBoolExp>;
}


export interface QueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRolesOrderBy>>;
  where?: Maybe<AuthRolesBoolExp>;
}


export interface QueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface QueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<PrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateAdressesOrderBy>>;
  where?: Maybe<PrivateAdressesBoolExp>;
}


export interface QueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<PrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateAdressesOrderBy>>;
  where?: Maybe<PrivateAdressesBoolExp>;
}


export interface QueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateBirthdaysOrderBy>>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}


export interface QueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateBirthdaysOrderBy>>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}


export interface QueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}


export interface QueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}


export interface QueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivatePhoneNumbersOrderBy>>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}


export interface QueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivatePhoneNumbersOrderBy>>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}


export interface QueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


export interface QueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


export interface QueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<SchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsOrderBy>>;
  where?: Maybe<SchoolSettingsBoolExp>;
}


export interface QueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<SchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsOrderBy>>;
  where?: Maybe<SchoolSettingsBoolExp>;
}


export interface QueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsModulesOrderBy>>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}


export interface QueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsModulesOrderBy>>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}


export interface QueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<SchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolsOrderBy>>;
  where?: Maybe<SchoolsBoolExp>;
}


export interface QueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<SchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolsOrderBy>>;
  where?: Maybe<SchoolsBoolExp>;
}


export interface QueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootUsersArgs {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
}


export interface QueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
}


export interface QueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface Relationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<Users>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<AuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface RelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<RelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Relationships>>;
}

/** aggregate fields of "relationships" */
export interface RelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<RelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<RelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface RelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<RelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface RelationshipsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<RelationshipsMaxOrderBy>;
  min?: Maybe<RelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface RelationshipsArrRelInsertInput {
  data: Array<RelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<RelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface RelationshipsBoolExp {
  _and?: Maybe<Array<RelationshipsBoolExp>>;
  _not?: Maybe<RelationshipsBoolExp>;
  _or?: Maybe<Array<RelationshipsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  related?: Maybe<UsersBoolExp>;
  related_id?: Maybe<UuidComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  roleByRole?: Maybe<AuthRolesBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum RelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface RelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<UsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<AuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface RelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface RelationshipsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface RelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface RelationshipsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface RelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Relationships>>;
}

/** on conflict condition type for table "relationships" */
export interface RelationshipsOnConflict {
  constraint: RelationshipsConstraint;
  update_columns?: Array<RelationshipsUpdateColumn>;
  where?: Maybe<RelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface RelationshipsOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related?: Maybe<UsersOrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  roleByRole?: Maybe<AuthRolesOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: relationships */
export interface RelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum RelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface RelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum RelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface SchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<Schools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface SchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<SchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface SchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface SchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface SchoolSettingsBoolExp {
  _and?: Maybe<Array<SchoolSettingsBoolExp>>;
  _not?: Maybe<SchoolSettingsBoolExp>;
  _or?: Maybe<Array<SchoolSettingsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  school?: Maybe<SchoolsBoolExp>;
  school_id?: Maybe<UuidComparisonExp>;
  school_settings_module?: Maybe<SchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum SchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface SchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<SchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<SchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface SchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface SchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface SchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<SchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface SchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<SchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface SchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface SchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface SchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<SchoolSettingsModulesBoolExp>>;
  _not?: Maybe<SchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<SchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<BooleanComparisonExp>;
  chat?: Maybe<BooleanComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grading?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  live_class?: Maybe<BooleanComparisonExp>;
  school_setting?: Maybe<SchoolSettingsBoolExp>;
  school_settings_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum SchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface SchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<SchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface SchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface SchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface SchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<SchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface SchoolSettingsModulesObjRelInsertInput {
  data: SchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface SchoolSettingsModulesOnConflict {
  constraint: SchoolSettingsModulesConstraint;
  update_columns?: Array<SchoolSettingsModulesUpdateColumn>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface SchoolSettingsModulesOrderBy {
  assignments?: Maybe<OrderBy>;
  chat?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  grading?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  live_class?: Maybe<OrderBy>;
  school_setting?: Maybe<SchoolSettingsOrderBy>;
  school_settings_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface SchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum SchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface SchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum SchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface SchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<SchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface SchoolSettingsObjRelInsertInput {
  data: SchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface SchoolSettingsOnConflict {
  constraint: SchoolSettingsConstraint;
  update_columns?: Array<SchoolSettingsUpdateColumn>;
  where?: Maybe<SchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface SchoolSettingsOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  school?: Maybe<SchoolsOrderBy>;
  school_id?: Maybe<OrderBy>;
  school_settings_module?: Maybe<SchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: school_settings */
export interface SchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum SchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface SchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum SchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface Schools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface SchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Schools>>;
}

/** aggregate fields of "schools" */
export interface SchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface SchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface SchoolsBoolExp {
  _and?: Maybe<Array<SchoolsBoolExp>>;
  _not?: Maybe<SchoolsBoolExp>;
  _or?: Maybe<Array<SchoolsBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  school_setting?: Maybe<SchoolSettingsBoolExp>;
  serial?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum SchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface SchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<SchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface SchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface SchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface SchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Schools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface SchoolsObjRelInsertInput {
  data: SchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface SchoolsOnConflict {
  constraint: SchoolsConstraint;
  update_columns?: Array<SchoolsUpdateColumn>;
  where?: Maybe<SchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface SchoolsOrderBy {
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  school_setting?: Maybe<SchoolSettingsOrderBy>;
  serial?: Maybe<OrderBy>;
}

/** primary key columns input for table: schools */
export interface SchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum SchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface SchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum SchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface TimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}

/** columns and relationships of "users" */
export interface Users {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<Relationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<Relationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface UsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<UsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Users>>;
}

/** aggregate fields of "users" */
export interface UsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<UsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<UsersMinFields>>;
}


/** aggregate fields of "users" */
export interface UsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<UsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface UsersBoolExp {
  _and?: Maybe<Array<UsersBoolExp>>;
  _not?: Maybe<UsersBoolExp>;
  _or?: Maybe<Array<UsersBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  address?: Maybe<PrivateAdressesBoolExp>;
  avatar_url?: Maybe<StringComparisonExp>;
  birthday?: Maybe<PrivateBirthdaysBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  first_name?: Maybe<StringComparisonExp>;
  full_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  insurance_number?: Maybe<PrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<StringComparisonExp>;
  phone_number?: Maybe<PrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<RelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<RelationshipsBoolExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum UsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface UsersInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  address?: Maybe<PrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<PrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<PrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<PrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<RelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<RelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface UsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface UsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface UsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Users>>;
}

/** input type for inserting object relation for remote table "users" */
export interface UsersObjRelInsertInput {
  data: UsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<UsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface UsersOnConflict {
  constraint: UsersConstraint;
  update_columns?: Array<UsersUpdateColumn>;
  where?: Maybe<UsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface UsersOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  address?: Maybe<PrivateAdressesOrderBy>;
  avatar_url?: Maybe<OrderBy>;
  birthday?: Maybe<PrivateBirthdaysOrderBy>;
  created_at?: Maybe<OrderBy>;
  first_name?: Maybe<OrderBy>;
  full_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  insurance_number?: Maybe<PrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<OrderBy>;
  phone_number?: Maybe<PrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: users */
export interface UsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum UsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface UsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum UsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface UuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { login_email_password?: Maybe<{ jwt_token?: Maybe<string>, refresh_token?: Maybe<string>, directus_token?: Maybe<string> }> };

export type LoginEmailAndPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginEmailAndPasswordMutation = { login_email_password?: Maybe<{ jwt_expires_in?: Maybe<string>, jwt_token?: Maybe<string>, refresh_token?: Maybe<string> }> };

export type LostPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type LostPasswordMutation = { lost_password?: Maybe<{ message?: Maybe<string> }> };

export type RefreshTokenMutationVariables = Exact<{
  refresh_token: Scalars['String'];
}>;


export type RefreshTokenMutation = { refresh_token?: Maybe<{ jwt_expires_in?: Maybe<string>, jwt_token?: Maybe<string>, refresh_token?: Maybe<string> }> };


export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login_email_password(email: $email, password: $password) {
    jwt_token
    refresh_token
    directus_token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginEmailAndPasswordDocument = gql`
    mutation LoginEmailAndPassword($email: String!, $password: String!) {
  login_email_password(email: $email, password: $password) {
    jwt_expires_in
    jwt_token
    refresh_token
  }
}
    `;
export type LoginEmailAndPasswordMutationFn = Apollo.MutationFunction<LoginEmailAndPasswordMutation, LoginEmailAndPasswordMutationVariables>;

/**
 * __useLoginEmailAndPasswordMutation__
 *
 * To run a mutation, you first call `useLoginEmailAndPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEmailAndPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEmailAndPasswordMutation, { data, loading, error }] = useLoginEmailAndPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginEmailAndPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginEmailAndPasswordMutation, LoginEmailAndPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginEmailAndPasswordMutation, LoginEmailAndPasswordMutationVariables>(LoginEmailAndPasswordDocument, options);
      }
export type LoginEmailAndPasswordMutationHookResult = ReturnType<typeof useLoginEmailAndPasswordMutation>;
export type LoginEmailAndPasswordMutationResult = Apollo.MutationResult<LoginEmailAndPasswordMutation>;
export type LoginEmailAndPasswordMutationOptions = Apollo.BaseMutationOptions<LoginEmailAndPasswordMutation, LoginEmailAndPasswordMutationVariables>;
export const LostPasswordDocument = gql`
    mutation LostPassword($email: String!) {
  lost_password(email: $email) {
    message
  }
}
    `;
export type LostPasswordMutationFn = Apollo.MutationFunction<LostPasswordMutation, LostPasswordMutationVariables>;

/**
 * __useLostPasswordMutation__
 *
 * To run a mutation, you first call `useLostPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLostPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lostPasswordMutation, { data, loading, error }] = useLostPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLostPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LostPasswordMutation, LostPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LostPasswordMutation, LostPasswordMutationVariables>(LostPasswordDocument, options);
      }
export type LostPasswordMutationHookResult = ReturnType<typeof useLostPasswordMutation>;
export type LostPasswordMutationResult = Apollo.MutationResult<LostPasswordMutation>;
export type LostPasswordMutationOptions = Apollo.BaseMutationOptions<LostPasswordMutation, LostPasswordMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refresh_token: String!) {
  refresh_token(refresh_token: $refresh_token) {
    jwt_expires_in
    jwt_token
    refresh_token
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;